const localStorageKeys = {
  globalComponentsContext: 'lkp_cmts_ctx',
  headerFiltersContext: 'lkp_hf_ctx',
  authContext: 'lkp_auth_ctx',
  permissionContext: 'lkp_permission_ctx',
};

export { localStorageKeys };
